const sectionId = 'template--23672954913008__gpu-reviews';
const selector = '[data-tg-review-sync-url]';
const cache = new Map();
const pending = new Map();
const observed = new WeakSet();

const renderSummary = (card, summary) => {
  const review = card.querySelector('.tg-card-proof__reviews');
  if (!review) return;
  const count = Number(summary.count) || 0;
  const ratedCount = Number(summary.ratedCount) || 0;
  const average = Number(summary.average) || 0;
  if (count < 1 || ratedCount < 1) {
    review.className = 'tg-card-proof__reviews tg-card-proof__reviews--empty';
    review.setAttribute('aria-label', 'レビューはまだありません');
    review.innerHTML = '<span class="tg-card-proof__stars" aria-hidden="true">☆☆☆☆☆</span><span>レビュー 0件</span>';
    return;
  }
  const rounded = Math.round(average);
  const stars = '★'.repeat(rounded) + '☆'.repeat(5 - rounded);
  review.className = 'tg-card-proof__reviews';
  review.setAttribute('aria-label', `5点中${average.toFixed(1)}点、${count}件のレビュー`);
  review.innerHTML = `<span class="tg-card-proof__stars" aria-hidden="true">${stars}</span><strong>${average.toFixed(1)}</strong><span>レビュー ${count}件</span>`;
};

const parseSection = (markup) => {
  const documentFragment = new DOMParser().parseFromString(markup || '', 'text/html');
  const section = documentFragment.querySelector('[data-tg-gpu-review-section]');
  if (!section) return { count: 0, ratedCount: 0, average: 0 };
  return {
    count: section.dataset.reviewCount,
    ratedCount: section.dataset.ratedCount,
    average: section.dataset.ratingAverage
  };
};

const fetchSummary = async (url) => {
  const endpoint = new URL(url, window.location.origin);
  endpoint.searchParams.set('sections', sectionId);
  const response = await fetch(endpoint, { credentials: 'same-origin' });
  if (!response.ok) throw new Error(`Review summary request failed: ${response.status}`);
  const payload = await response.json();
  const markup = payload[sectionId];
  if (markup !== null && markup !== undefined) return parseSection(markup);

  const fallbackResponse = await fetch(new URL(url, window.location.origin), { credentials: 'same-origin' });
  if (!fallbackResponse.ok) throw new Error(`Review page request failed: ${fallbackResponse.status}`);
  return parseSection(await fallbackResponse.text());
};

const syncCard = async (card) => {
  const key = card.dataset.tgReviewSyncKey;
  const url = card.dataset.tgReviewSyncUrl;
  if (!key || !url) return;
  if (cache.has(key)) {
    renderSummary(card, cache.get(key));
    return;
  }
  if (!pending.has(key)) {
    const request = fetchSummary(url)
      .then((summary) => {
        cache.set(key, summary);
        document.querySelectorAll(selector).forEach((candidate) => {
          if (candidate.dataset.tgReviewSyncKey === key) renderSummary(candidate, summary);
        });
        return summary;
      })
      .catch(() => null)
      .finally(() => pending.delete(key));
    pending.set(key, request);
  }
  await pending.get(key);
};

const observer = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        syncCard(entry.target);
      });
    }, { rootMargin: '300px 0px' })
  : null;

const observeCards = () => {
  document.querySelectorAll(selector).forEach((card) => {
    if (observed.has(card)) return;
    observed.add(card);
    if (observer) observer.observe(card);
    else syncCard(card);
  });
};

observeCards();
const mutationObserver = new MutationObserver(observeCards);
mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
